export const HOST_BROWSER_AUDIO_TRACK_NAME = 'host-browser-audio';
